<template>
    <div class="Layout-right">
        <Header />
        <Breadcrumbs />
    <div class="main">
    <router-view />

    </div>
    </div>
</template>

<script>
import Header from './Header.vue'
import Breadcrumbs from "./breadcrumbs.vue"
    export default {
        components:{
            Header,
            Breadcrumbs
        }
        
    }
</script>

<style lang="less" scoped>
.Layout-right{
    flex: 1;
    display: flex;
    flex-direction: column;
}
.main{
    flex: 1;
    background: #ebeef5;
    padding: 15px;
    overflow-y: scroll;
}
</style>